import { createContext, useContext, useReducer } from 'react';
import { HomeState, HomeReducer, ACTION_TYPES } from './home-reducer';


const HomeContext = createContext<HomeState | undefined>(undefined);
const HomeContextDispatchContext = createContext({} as any);

 const HomeProvider=({ children }: { children: React.ReactNode })=> {
    const [state, dispatch] = useReducer(HomeReducer, {} as HomeState);

    return (
        <HomeContext.Provider value={state}>
            <HomeContextDispatchContext.Provider value={dispatch}>
                {children}
            </HomeContextDispatchContext.Provider>
        </HomeContext.Provider>
    );
}

 const useHomeState=()=>{
    const context = useContext(HomeContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

 const  useHomeDispatch=()=> {
    const context = useContext(HomeContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
 }

export {    HomeProvider,useHomeDispatch,useHomeState,ACTION_TYPES};

